// extracted by mini-css-extract-plugin
export var downArrow = "_a3-0";
export var infoTooltipIcon = "_a3-3";
export var label = "_a3-1";
export var optionCard = "_a3-4";
export var upArrow = "_a3-2";